import { createSlice } from "@reduxjs/toolkit";

import { InvoiceStatus } from "@/shared/types";

import { InitialStateType, SLICE_NAME, CaseReducers } from "./types/types";

const INITIAL_STATE: InitialStateType = {
  data: { items: [], count: 0 },
  params: { status: InvoiceStatus.PENDING },
};

const slice = createSlice<
  InitialStateType,
  CaseReducers<InitialStateType>,
  typeof SLICE_NAME,
  never
>({
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    setParams: (draft, { payload }) => {
      draft.params = { ...draft.params, ...payload.params };
    },
    setInvoices: (draft, { payload }) => {
      draft.data = payload.invoices;
    },
  },
});

export const invoicesSlice = slice.actions;
export const invoicesReducer = slice.reducer;
